import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { sessionExpiredStore } from '@/auth/session-expired-store.ts';
import { ApiError } from '@/lib/api.ts';

export function shouldRetry(failureCount: number, error: unknown): boolean {
  // Client errors (401, 403, 404, 409, 422...) will not change on retry.
  if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
  return failureCount < 2;
}

export interface QueryClientOptions {
  /** Called when any query or mutation fails with 401. Defaults to opening the dialog. */
  onUnauthorized?: () => void;
}

export function createQueryClient({
  onUnauthorized = sessionExpiredStore.open,
}: QueryClientOptions = {}): QueryClient {
  const handleError = (error: unknown) => {
    if (error instanceof ApiError && error.status === 401) onUnauthorized();
  };
  return new QueryClient({
    queryCache: new QueryCache({ onError: handleError }),
    mutationCache: new MutationCache({ onError: handleError }),
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        refetchOnWindowFocus: false,
      },
    },
  });
}
